// ============================================================
// Activity Risk Tags — app-local mirror of the canonical
// `mozaic-shared/src/constants/activityRiskTags.ts` list.
//
// Per ARCH-A6 (Session A.7): the canonical taxonomy file is
// authored in `mozaic-shared`, but neither app imports from it
// directly today (no workspace link — deferred to Walk phase).
// This mirror is what ActivitiesForm and ForecastingForm
// import. Cross-app sync with the mobile mirror and the
// canonical shared file is a manual discipline item — same
// pattern as `HUB_SECTIONS_BY_VARIANT`.
// ============================================================

export const ACTIVITY_RISK_TAGS: readonly string[] = [
  '#HotWork',
  '#ConfinedSpace',
  '#WorkingAtHeight',
  '#LiftingOperations',
  '#H2S',
  '#HighPressure',
  '#LOTO',
  '#NightOps',
  '#SimOps',
  '#SIFActivity',
  '#DroppedObjects',
  '#CraneOps',
  '#DivingOps',
  '#ChemicalHandling',
  '#ProcessSafety',
  '#PiggingOps',
  '#WellTesting',
] as const;
